import { useMutation } from "react-query";
import { useAuthentication } from "../useAuthentication.ts";

export const useMutationDeleteEnrollee = () => {
  const { accessToken } = useAuthentication();

  return useMutation(
    async ({
      sourceId,
      projectId,
      enrolleeId,
    }: {
      sourceId: string;
      projectId: string;
      enrolleeId: string;
    }) => {
      const response = await fetch(
        `${
          import.meta.env.VITE_API_HOST
        }/sources/${sourceId}/projects/${projectId}/enrollees/${enrolleeId}`,
        {
          method: "DELETE",
          headers: {
            authorization: accessToken ?? "",
          },
        },
      );

      if (!response.ok) {
        throw new Error("Failed to delete enrollee");
      }
    },
    {
      onError: (error, data) => {
        console.error("Failed to delete enrollee", error, data);
      },
    },
  );
};
